import { LabelBody } from './LabelBody';
import { ChevronDown } from '../icons';
import classNames from 'classnames';

type SelectOption<T extends number | string> = {
    value: T;
    label: string;
};

type InputSelectProps<T extends number | string> = {
    label: string;
    value: T | null;
    onChange: (value: T | null) => void;
    options?: SelectOption<T>[];
    disabled?: boolean;
    placeholder?: string;
    type?: 'select' | 'time';
    className?: string;
};

export default function InputSelect<T extends number | string>({
    label,
    value,
    onChange,
    options = [],
    disabled = false,
    // TODO: NOR-94
    placeholder = 'Vælg',
    type = 'select',
    className = '',
}: InputSelectProps<T>) {
    const selectedLabel =
        options.find((option) => option.value === value)?.label ??
        (value !== null && value !== '' ? String(value) : placeholder);

    return (
        <>
            <LabelBody
                className={classNames('mb-5', disabled ? 'opacity-30' : '')}
            >
                {label}
            </LabelBody>
            <label className={classNames('relative mb-30 block', className)}>
                <div
                    className={classNames(
                        'flex items-center justify-between border p-10 text-base',
                        value === null || value === '' ? 'italic' : '',
                        disabled
                            ? 'cursor-not-allowed border-grey bg-cool-grey text-grey opacity-30'
                            : 'border-grey-textfield bg-white',
                    )}
                >
                    {selectedLabel}
                    <ChevronDown className="text-grey" />
                </div>

                {type === 'time' ? (
                    <input
                        type="time"
                        value={String(value ?? '')}
                        onChange={(event) => onChange(event.target.value as T)}
                        disabled={disabled}
                        className="absolute inset-0 h-full w-full opacity-0"
                    />
                ) : (
                    <select
                        value={value ?? ''}
                        onChange={(event) => {
                            const selectedValue = event.target.value;
                            const option = options.find(
                                (item) => String(item.value) === selectedValue,
                            );

                            onChange(option ? option.value : null);
                        }}
                        disabled={disabled}
                        className="absolute inset-0 h-full w-full opacity-0"
                    >
                        <option value="" disabled hidden>
                            {placeholder}
                        </option>{' '}
                        {options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                )}
            </label>
        </>
    );
}
